export default __webpack_public_path__ + "static/media/1357.a7af81f5.png";